import axios from 'axios'
import { baseUrl } from '../constants'
const URL = baseUrl

const config = (token) => { return { 
    withCredentials: true,
    headers: { Authorization: `Bearer ${token}`, }, 
  } }
  

const getImages = async (data, token) => {
    const response = await axios.post(URL+'/api/images/getImages' , data, config(token))
    return response.data
}

const uploadImages = async (data, token) => {
    const response = await axios.post(URL+'/api/images/uploadImages' , data, config(token))
    return response.data
}

const deleteImage = async (data, token) => {
    const response = await axios.post(URL+'/api/images/deleteImage' , data, config(token))
    return response.data
}


const imagesService = {
    uploadImages, getImages , deleteImage
}

export default imagesService